export default __webpack_public_path__ + "static/media/a020-cs-3.51776aa0.svg";